
import FTextField from '@/components/atoms/forms/h-text-field';

export default {
  name: 'FCurrencyField',

  components: {
    FTextField,
  },

  props: {
    disabled: {
      type: Boolean,
    },
    disabledPlaceholder: {
      type: [String, Number, null],
      default: '',
    },
    inputMode: {
      type: String,
      default: 'decimal',
    },
    inputValue: {
      type: [String, Number, null],
      default: '',
    },
    suffix: {
      type: String,
      default: '%',
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    errorMessageFullWith: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    backgroundColor: {
      type: String,
    },
    color: {
      type: String,
    },
    inlineEditor: {
      type: Boolean,
    },
  },

  data() {
    return {
      value: '',
    };
  },

  computed: {
    type() {
      return this.disabled && this.disabledPlaceholder ? 'text' : 'number';
    },
    renderedValue: {
      get() {
        return this.disabled && this.disabledPlaceholder
          ? this.disabledPlaceholder
          : this.value;
      },
      set(value) {
        this.value = value;
      },
    },
  },

  watch: {
    inputValue() {
      this.formatValue();
    },
  },

  mounted() {
    this.formatValue();
  },

  methods: {
    formatValue() {
      this.value = this.getFormattedStringValue(this.inputValue).replace(
        '.',
        ',',
      );
    },

    getFormattedStringValue(value) {
      if (!value && value !== 0 && value !== '0') {
        return '';
      }

      let formattedValue = value;

      const parsedValue = parseFloat(value.toString().replace(',', '.'));

      if (parsedValue < 0) {
        formattedValue = 0;
      } else if (parsedValue > 100) {
        formattedValue = 100;
      }

      return formattedValue.toString();
    },

    handleBlur(e) {
      this.$emit('blur', e);
    },

    handleChange(e) {
      this.$emit('change', e);
    },

    handleFocus(e) {
      this.$emit('focus', e);
    },

    handleInput() {
      this.$emit(
        'input',
        parseFloat(this.getFormattedStringValue(this.value).replace(',', '.')),
      );
    },

    handleKeyDown(e) {
      const specialKeys = [
        8, // Backspase
        9, // Tab
        37, // Left arrow
        38, // Up arrow
        39, // Right arrow
        40, // Down arrow
        188, // Comma
        190, // Period
      ];

      const keyCode = e.which ? e.which : e.keyCode;
      const numberValue = parseInt(e.key);
      const isNumberOrSpecial =
        numberValue || numberValue === 0 || specialKeys.includes(keyCode);

      const hasDelimiter =
        this.value.toString().includes(',') ||
        this.value.toString().includes('.');

      if (
        !isNumberOrSpecial ||
        (hasDelimiter && (keyCode === 190 || keyCode === 188)) ||
        this.value.split('.')[1]?.length > 1
      ) {
        e.preventDefault();
      }
    },
  },
};
